import React from 'react';

export default function CenterHorizontal({ children }) {
	return <div style={{ display: 'flex', justifyContent: 'center' }}>
		{children}
	</div>;
}
